import type { ReactElement } from "react";
import { Logo } from "@olivahealth/oli-ui";
import { useRouter } from "next/router";
import Navbar from "../Navbar";
import useNavbar from "../Navbar/useNavbar";
import * as s from "./styles";

export default function Header({
  showLogo = true,
  showNavBar = true,
}: {
  showLogo?: boolean;
  showNavBar?: boolean;
}): ReactElement | null {
  const { push } = useRouter();

  const { data } = useNavbar();
  const isLightVariant = data?.isProfessional ?? false;
  if (!showLogo && !showNavBar) {
    return null;
  }

  return (
    <header className={isLightVariant ? s.header : s.headerDark}>
      {showLogo && (
        <div className="flex items-center">
          <button aria-label="return to home" onClick={() => push("/")}>
            <Logo height={26} color={isLightVariant ? "light" : "white"} />
          </button>
        </div>
      )}
      {showNavBar && <Navbar variant={isLightVariant ? "light" : "dark"} />}
    </header>
  );
}
